export default __webpack_public_path__ + "static/media/79241523718895061132599219194837638887709880144791119010511829414463931942.gif.52f3ea19.mp4";